import { render, staticRenderFns } from "./bannerDetail.vue?vue&type=template&id=0a8d9666&scoped=true"
import script from "./bannerDetail.vue?vue&type=script&lang=js"
export * from "./bannerDetail.vue?vue&type=script&lang=js"
import style0 from "./bannerDetail.vue?vue&type=style&index=0&id=0a8d9666&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d9666",
  null
  
)

export default component.exports